import { Picture } from '@common-types';

import { COLLEGES_IMAGES_URL } from '@constants/externalRoutes';

export function getImageSrc(id: number, defaultPicture: string, picture: Picture) {
  let src = defaultPicture;

  if (picture?.pictureSource === 'defaultTradeSchoolImage') {
    src = `${COLLEGES_IMAGES_URL}/${encodeURIComponent(picture.name)}`;
  } else if (picture?.name) {
    src = `${COLLEGES_IMAGES_URL}/${id}/${encodeURIComponent(picture.name)}`;
  }

  return src;
}
